import React from 'react';
import FieldBold from '../../Fields/FieldBold/FieldBold';

import classes from './DetailBank.module.scss';

const DetailBank = ({ bank, methodForPay, subtypeLabel, bankNumber, name, identification }) => {
  return (
    <div className={classes.content}>
      <span className='bold-20'>Detalles de cuenta bancaria</span>
      <FieldBold title='BANCO'>{bank}</FieldBold>
      {!(methodForPay === 'PSEPay' || methodForPay === 'cybersource') && <FieldBold title='TIPO DE CUENTA' value={subtypeLabel} />}
      {!(methodForPay === 'PSEPay' || methodForPay === 'cybersource') && <FieldBold title='NÚMERO DE CUENTA' value={bankNumber} />}
      <FieldBold title='TITULAR DE CUENTA' value={name} />
      <FieldBold title='IDENTIFICACIÓN DEL TITULAR' value={identification} />
    </div>
  );
};

export default DetailBank;
